// Live events fan out beyond the board snapshot: pages that load their own data (chats, ontologies, members, …)
// listen here by kind and reload. live/index.ts emits every applied event's kind (namespaced, e.g. hq.chat.Message).
type Listener = (kind: string, id: string) => void;
const listeners = new Set<Listener>();

export function onLive(l: Listener): () => void {
	listeners.add(l);
	return () => listeners.delete(l);
}

export function emitLive(kind: string, id: string) {
	for (const l of listeners) l(kind, id);
}
